module.exports = __webpack_public_path__ + "img/Slider-IMMO_en.1faef54a.png";